import { render } from "./Inquiry.m.backup.vue?vue&type=template&id=0bbc747f&scoped=true"
import script from "./Inquiry.m.backup.vue?vue&type=script&lang=js"
export * from "./Inquiry.m.backup.vue?vue&type=script&lang=js"

import "./Inquiry.m.backup.vue?vue&type=style&index=0&id=0bbc747f&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbc747f"]])

export default __exports__